// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NH2G","col":"styles_col__12-nl"};